import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { EMPTY, catchError, throwError } from 'rxjs';

import { Auth } from '../services/auth';

// Endpoint pubblici di autenticazione: non richiedono mai un token, e un 401
// qui significa "credenziali errate", non "sessione scaduta" — non vanno
// gestiti dalla logica di logout automatico qui sotto.
// endsWith (non startsWith su '/api/...') perché in staging apiUrlInterceptor,
// eseguito prima, riscrive l'URL rimuovendo il prefisso '/api'.
const PUBLIC_AUTH_PATHS = [
  '/login',
  '/auth/registration-login',
  '/auth/complete-first-login',
  '/auth/forgot-password',
  '/auth/reset-password',
];

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  if (PUBLIC_AUTH_PATHS.some((path) => req.url.endsWith(path))) {
    return next(req);
  }

  const auth = inject(Auth);
  const router = inject(Router);
  const token = auth.getToken();

  if (!token) {
    return next(req);
  }

  return next(
    req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    }),
  ).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse && error.status === 401) {
        auth.removeToken();
        void router.navigateByUrl('/login').catch(() => undefined);
        return EMPTY;
      }

      return throwError(() => error);
    }),
  );
};
